export const uk = {
    'adgroup-demography-multipliers': 'Корректировки ставок на группу по полу и возрасту',
    'adgroup-mobile-multiplier': 'Корректировки ставок на группу для мобильных',
    'adgroup-performance-tgo-multiplier': 'Корректировки ставок на группу для cмарт-объявлений',
    'adgroup-regions': 'Регион показов на группу',
    'adgroup-retargeting-multipliers': 'Корректировки ставок на группу для целевой аудитории',
    'adgroup-video-multiplier': 'Корректировки ставок на группу для видеодополнений',
    'banner-status': 'Статус объявления',
    'banners-archived': 'Объявление перенесено в архив',
    'banners-hide': 'Объявление остановлено',
    'banners-show': 'Объявление включено',
    'banners-unarchived': 'Объявление разархивировано',
    'campaign-archived': 'Кампания перенесена в архив',
    'campaign-broad-match': 'Дополнительные релевантные фразы',
    'campaign-creation': 'Кампания создана',
    'campaign-demography-multipliers': 'Корректировки ставок по полу и возрасту',
    'campaign-disabled-domains': 'Запрещённые площадки',
    'campaign-disabled-ips': 'Запрещённые IP-адреса',
    'campaign-disabled-ssp': 'Запрещённые внешние сети',
    'campaign-extended-geotargeting': 'Расширенный географический таргетинг',
    'campaign-finish-time': 'Дата окончания кампании',
    'campaign-hide': 'Кампания остановлена',
    'campaign-minus-words': 'Минус-фразы для кампании',
    'campaign-mobile-multiplier': 'Корректировки ставок для мобильных',
    'campaign-network': 'Настройки в сетях',
    'campaign-performance-tgo-multiplier': ' Корректировки ставок для смарт-объявлений',
    'campaign-regions': 'Регион показов',
    'campaign-restrict-frequency': 'Ограничение частоты показов',
    'campaign-retargeting-multipliers': 'Корректировки ставок для целевой аудитории',
    'campaign-show': 'Кампания включена',
    'campaign-start-time': 'Дата начала кампании',
    'campaign-status': 'Статус кампании',
    'campaign-strategy': 'Стратегия',
    'campaign-time-target': 'Временной таргетинг',
    'campaign-unarchived': 'Кампания разархивирована',
    'campaign-video-multiplier': 'Корректировки ставок для видеодополнений',
    off: 'Выключен',
    on: 'Включён',
    yandex: 'Яндекс'
};
